import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/**
 * SMS-003: Modal para enviar um evento de teste para o webhook da integração.
 * Aberto via NgbModal (padrão do projeto). O payload validado é retornado pelo
 * close() do NgbActiveModal.
 */
@Component({
  selector: 'app-test-event-modal',
  templateUrl: './test-event-modal.component.html',
  styleUrls: ['./test-event-modal.component.scss']
})
export class TestEventModalComponent implements OnInit {

  /** Payload inicial (último real do buffer ou payload_schema do template). */
  @Input() lastPayload: any = {};

  payloadJson = '{}';
  jsonError: string | null = null;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    if (this.lastPayload && Object.keys(this.lastPayload).length > 0) {
      this.payloadJson = JSON.stringify(this.lastPayload, null, 2);
    }
  }

  /**
   * Valida o JSON e fecha o modal devolvendo o payload.
   */
  submit(): void {
    this.jsonError = null;

    try {
      const payload = JSON.parse(this.payloadJson);
      this.activeModal.close(payload);
    } catch (e: any) {
      this.jsonError = `JSON inválido: ${e.message}`;
    }
  }

  cancel(): void {
    this.activeModal.dismiss();
  }

  onJsonChange(): void {
    this.jsonError = null;
  }
}
